package devxertech.com.pages.industries.common

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.CSSLengthOrPercentageNumericValue
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextTransform
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.letterSpacing
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.textTransform
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Constants
import kotlinx.browser.window
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.H3


@Composable
fun ManagementSoftware(image: String, sideImage: String, title: String, description: String, imageWidth: CSSLengthOrPercentageNumericValue = 0.px,
                       imageHeight: CSSLengthOrPercentageNumericValue = 0.px, commonChanges: Boolean = false, educationChanges: Boolean = false,
                       fintechChanges: Boolean = false, educationalChanges: Boolean = false) {
    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()

    val cardHeight = if (breakpoint > Breakpoint.MD) 503.px else 420.px
    val contentHeight = 420.px
    val titleHeight = 60.px
    val descriptionHeight = if (window.screen.width < 768) 190.px else 150.px

    Box(
        modifier = Modifier
            .width(
                when {
                    window.screen.width > 1610 -> 400.px
                    window.screen.width in 1441..1600 -> 400.px
                    window.screen.width == 1440 -> 350.px
                    breakpoint == Breakpoint.MD -> 340.px
                    window.screen.width < 375 -> 290.px
                    else -> 320.px
                }
            )
            .height(cardHeight)
            .margin(topBottom = 20.px)
            .backgroundColor(sitePalette.modalBackgroundColor.rgb)
            .borderRadius(1.px)
            .boxShadow(
                blurRadius = 12.8.px,
                offsetY = 7.px,
                spreadRadius = (0).px,
                color = Colors.LightGray
            ),
        contentAlignment = Alignment.Center
    ) {
        Row(
            modifier = Modifier.fillMaxWidth(),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            Image(
                src = sideImage,
                modifier = Modifier.attrsModifier { attr("alt", "") }
                    .width(if (breakpoint > Breakpoint.MD) 87.px else 50.px)
                    .height(172.px)
                    .align(Alignment.CenterVertically)
                    .zIndex(1)
            )
            Box(
                modifier = Modifier
                    .width(300.px)
                    .height(contentHeight)
                    .backgroundColor(Colors.White)
                    .borderRadius(12.px),
                contentAlignment = Alignment.Center
            ) {
                Column(
                    modifier = Modifier.fillMaxSize()
                        .padding(top = 85.px, right = if (breakpoint < Breakpoint.MD) 20.px else 38.px, bottom = 20.px),
                    verticalArrangement = Arrangement.Center,
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    Box(
                        modifier = Modifier.width(imageWidth).height(imageHeight)
                            .margin(bottom = 20.px, left = if (commonChanges) 35.px else 0.px,
                            top = if (educationChanges) (-10).px else 0.px),
                        contentAlignment = Alignment.Center
                    ) {
                        Image(src = image, modifier = Modifier.attrsModifier { attr("alt", "") }.fillMaxSize())
                    }
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(titleHeight),
                        contentAlignment = Alignment.Center
                    ) {
                        H3(attrs = { style { property("margin", "0") } }) { SpanText(
                            text = title,
                            modifier = Modifier
                                .fontSize(if (window.screen.width < 375) 16.px else 18.px)
                                .fontFamily(Constants.FONT_FAMILY)
                                .color(sitePalette.commonSecondaryButtonColor.rgb)
                                .fontWeight(FontWeight.Bold)
                                .padding(bottom = if (breakpoint < Breakpoint.MD) 0.px else 10.px,
                                    left = 2.px, top = if (educationalChanges && breakpoint < Breakpoint.MD) 14.px else 0.px )
                                .margin(top = if (fintechChanges) (-40).px else 0.px)
                                .textAlign(TextAlign.Center)
                                .lineHeight(if (breakpoint > Breakpoint.MD) 23.px else 21.px)
                                .letterSpacing(0.1.px)
                                .textTransform(TextTransform.Uppercase)
                        ) }
                    }
                    Box(
                        modifier = Modifier
                            .fillMaxWidth(if (breakpoint < Breakpoint.MD) 250.px else 100.percent)
                            .height(descriptionHeight),
                        contentAlignment = Alignment.TopCenter
                    ) {
                        SpanText(
                            text = description,
                            modifier = Modifier
                                .fillMaxWidth()
                                .fontSize(14.px)
                                .fontFamily(Constants.FONT_FAMILY)
                                .textAlign(TextAlign.Center)
                                .whiteSpace(WhiteSpace.PreWrap)
                                .color(sitePalette.commonSecondaryButtonColor.rgb)
                                .fontWeight(FontWeight.Normal)
                                .lineHeight(if (breakpoint > Breakpoint.MD) 21.px else 20.px)
                                .margin(right = 15.px, top = if (breakpoint > Breakpoint.LG) 5.px
                                else if (educationChanges) 3.px else if (fintechChanges) 0.px else  0.px)
                        )
                    }
                }
            }
        }
    }
}
